import { render } from "./tpl_richText.vue?vue&type=template&id=0757fbb4&scoped=true"
import script from "./tpl_richText.vue?vue&type=script&lang=js"
export * from "./tpl_richText.vue?vue&type=script&lang=js"

import "./tpl_richText.vue?vue&type=style&index=0&id=0757fbb4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0757fbb4"],['__file',"src/views/dragger/template/tpl_richText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0757fbb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0757fbb4', __exports__)) {
    console.log('reload')
    api.reload('0757fbb4', __exports__)
  }
  
  module.hot.accept("./tpl_richText.vue?vue&type=template&id=0757fbb4&scoped=true", () => {
    console.log('re-render')
    api.rerender('0757fbb4', render)
  })

}


export default __exports__